import { SxProps, Theme } from "@mui/material";

export const streamNodeStyles: {
    container: SxProps<Theme>;
    iconWrapper: (selected: boolean) => SxProps<Theme>;
    addNodeContainer: SxProps<Theme>;
    addIconWrapper: SxProps<Theme>;
    addIcon: SxProps<Theme>;
    addNodePanel: SxProps<Theme>;
    availableNodesList: SxProps<Theme>;
    availableNodesListTitle: SxProps<Theme>;
    availableNodesListItem: (selected: boolean) => SxProps<Theme>;
    availableNodesListItemContent: SxProps<Theme>;
    availableNodesListItemIcon: SxProps<Theme>;
    availableNodesListItemLabel: SxProps<Theme>;
    availableNodesListItemCategory: SxProps<Theme>;
    connectButtonWrapper: SxProps<Theme>;
} = {
    container: {
        position: "relative"
    },
    iconWrapper: (selected: boolean): SxProps<Theme> => ({
        width: "32px",
        height: "32px",
        border: selected ? "2px solid #089bee" : "none",
        borderRadius: "16px",
        transform: selected ? "scale(1.2)" : "scale(1)",
        boxShadow: `0 4px 12px ${selected ? "#089bee59" : "rgba(0, 0, 0, 0.1)"}`
    }),
    addNodeContainer: {
        cursor: "pointer !important",
        position: "absolute",
        left: "calc(100% + 8px)",
        top: "50%",
        transform: "translateY(-50%)",
        display: "flex",
        alignItems: "center",
        gap: 1,
        zIndex: 2
    },
    addIconWrapper: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "white",
        borderRadius: "50%"
    },
    addIcon: {
        color: "#089bee",
        fontSize: 20
    },
    addNodePanel: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        minWidth: 200
    },
    availableNodesList: {
        display: "flex",
        flexDirection: "column",
        p: 1,
        bgcolor: "white",
        borderRadius: "10px",
        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.12)"
    },
    availableNodesListTitle: {
        color: "greyscale.700",
        fontWeight: 700,
        px: 0.5,
        mb: 1,
        textTransform: "uppercase",
        letterSpacing: "0.04em"
    },
    availableNodesListItem: (selected: boolean): SxProps<Theme> => ({
        display: "flex",
        justifyContent: "start",
        width: "100%",
        bgcolor: selected ? "rgba(8, 155, 238, 0.08)" : "transparent"
    }),
    availableNodesListItemContent: {
        display: "flex",
        alignItems: "center",
        minWidth: 0
    },
    availableNodesListItemIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    availableNodesListItemLabel: {
        color: "greyscale.900",
        textAlign: "left",
        mb: 1 / 2
    },
    availableNodesListItemCategory: {
        px: 1,
        py: 0.25,
        borderRadius: "999px",
        bgcolor: "greyscale.100",
        color: "greyscale.700",
        fontSize: "10px",
        fontWeight: 700,
        letterSpacing: "0.04em"
    },
    connectButtonWrapper: {
        display: "flex",
        justifyContent: "flex-end",
        pt: 0.5,
        gap: 1
    }
};
